export default __webpack_public_path__ + "static/media/offset_black_logo.97357400.svg";